import React from 'react';
import { BiAlignLeft, BiBrain } from 'react-icons/bi';
import {
  TbFileInvoice,
  TbBuildingStore,
  TbBuildingWarehouse,
  TbBuildingBank,
  TbSettings,
} from 'react-icons/tb';

const routesConfig = [
  {
    id: 'app',
    title: 'blueSoft',
    messageId: 'sidebar.blueSoft',
    type: 'group',
    idsFuncionalidad: [
      '878',
      '606',
      '607',
      '608',
      '609',
      '602',
      '701',
      '610',
      '103',
      '611',
      '801',
      '803',
      '805',
      '805',
      '807',
      '809',
      '306',
      '307',
      '308',
      '322',
      '302',
      '310',
      '702',
      '309',
      '101',
      '802',
      '804',
      '806',
      '808',
      '810',
      '825',
      '843',
      '844',
      '739',
      '742',
      '743',
      '304',
      '312',
      '605',
      '502',
      '507',
      '524',
      '401',
      '403',
    ],
    children: [
      {
        id: 'inicio',
        title: 'Inicio',
        messageId: 'sidebar.blueSoft.start',
        type: 'item',
        icon: <BiAlignLeft />,
        url: '/blueSoft/inicio',
      },
      {
        id: 'preguntaIA',
        title: 'Pregunta IA',
        messageId: 'sidebar.blueSoft.preguntaIA',
        type: 'item',
        url: '/blueSoft/ia/pregunta',
        icon: <BiBrain />,
        idsFuncionalidad: ['878'],
      },
      {
        id: 'ventas',
        title: 'Ventas',
        messageId: 'sidebar.blueSoft.sales',
        type: 'collapse',
        icon: <TbBuildingStore />,
        idsFuncionalidad: [
          '102',
          '606',
          '607',
          '608',
          '609',
          '602',
          '701',
          '610',
          '103',
          '611',
          '801',
          '803',
          '805',
          '805',
          '807',
          '809',
        ],
        children: [
          {
            id: 'facturasDeVenta',
            title: 'Facturas',
            messageId: 'sidebar.blueSoft.invoices',
            type: 'item',
            url: '/blueSoft/ventas/documentos',
            idsFuncionalidad: ['606', '607', '608', '609'],
          },
          {
            id: 'recibos',
            title: 'Recibos',
            messageId: 'sidebar.blueSoft.recibos',
            type: 'item',
            url: '/blueSoft/ventas/recibos',
            idsFuncionalidad: ['602'],
          },
          {
            id: 'pedidosDeVenta',
            title: 'Pedidos de Venta',
            messageId: 'sidebar.blueSoft.pedidosDeVenta',
            type: 'item',
            url: '/blueSoft/ventas/pedidos',
            idsFuncionalidad: ['603'],
          },
          {
            id: 'ctaCteClientes',
            title: 'Cuenta Corriente Clientes',
            messageId: 'sidebar.blueSoft.ctaCteClientes',
            type: 'item',
            url: '/blueSoft/ventas/ctacte',
            idsFuncionalidad: ['701', '610'],
          },
          {
            id: 'clientes',
            title: 'Clientes',
            messageId: 'sidebar.blueSoft.clientes',
            type: 'item',
            url: '/blueSoft/ventas/clientes',
            idsFuncionalidad: ['103', '611'],
          },
          {
            id: 'productos',
            title: 'Productos',
            messageId: 'sidebar.blueSoft.productos',
            type: 'item',
            url: '/blueSoft/ventas/productos',
            idsFuncionalidad: ['102'],
          },
          {
            id: 'analisisDeVentas',
            title: 'Análisis de Ventas',
            messageId: 'sidebar.blueSoft.analisisDeVentas',
            type: 'item',
            url: '/blueSoft/ventas/analisis',
            idsFuncionalidad: ['801', '803', '805', '805', '807', '809'],
          },
        ],
      },
      {
        id: 'compras',
        title: 'Compras',
        messageId: 'sidebar.blueSoft.expenses',
        type: 'collapse',
        icon: <TbFileInvoice />,
        idsFuncionalidad: [
          '166',
          '167',
          '306',
          '307',
          '308',
          '322',
          '302',
          '310',
          '702',
          '309',
          '101',
          '802',
          '804',
          '806',
          '808',
          '810',
          '825',
          '843',
          '844',
        ],
        children: [
          {
            id: 'facturasDeCompra',
            title: 'Facturas',
            messageId: 'sidebar.blueSoft.invoices',
            type: 'item',
            url: '/blueSoft/compras/documentos',
            idsFuncionalidad: ['306', '307', '308', '322'],
          },
          {
            id: 'pagos',
            title: 'Pagos',
            messageId: 'sidebar.blueSoft.pagos',
            type: 'item',
            url: '/blueSoft/compras/pagos',
            idsFuncionalidad: ['302'],
          },
          {
            id: 'ctaCteProveedores',
            title: 'Cuenta Corriente Proveedores',
            messageId: 'sidebar.blueSoft.ctaCteProveedores',
            type: 'item',
            url: '/blueSoft/compras/ctacte',
            idsFuncionalidad: ['310', '702'],
          },
          {
            id: 'proveedores',
            title: 'Proveedores',
            messageId: 'sidebar.blueSoft.proveedores',
            type: 'item',
            url: '/blueSoft/compras/proveedores',
            idsFuncionalidad: ['309', '101'],
          },
          {
            id: 'planDeCuentas',
            title: 'Plan de Cuentas',
            messageId: 'sidebar.blueSoft.planDeCuentas',
            type: 'item',
            url: '/blueSoft/compras/planDeCuentas',
            idsFuncionalidad: ['166'],
          },
          {
            id: 'materiasPrimas',
            title: 'Materias Primas',
            messageId: 'sidebar.blueSoft.materiasPrimas',
            type: 'item',
            url: '/blueSoft/compras/materiasPrimas',
            idsFuncionalidad: ['167'],
          },
          {
            id: 'analisisDeCompras',
            title: 'Análisis de Compras',
            messageId: 'sidebar.blueSoft.analisisDeCompras',
            type: 'item',
            url: '/blueSoft/compras/analisis',
            idsFuncionalidad: [
              '802',
              '804',
              '806',
              '808',
              '810',
              '825',
              '843',
              '844',
            ],
          },
        ],
      },
      {
        id: 'cajas',
        title: 'Cajas',
        messageId: 'sidebar.blueSoft.boxes',
        type: 'collapse',
        icon: <TbBuildingBank />,
        idsFuncionalidad: ['739', '742', '743'],
        children: [
          {
            id: 'movimientosDeCaja',
            title: 'Movimientos',
            messageId: 'sidebar.blueSoft.movements',
            type: 'item',
            url: '/blueSoft/cajas/movimientos',
            idsFuncionalidad: ['739', '742', '743'],
          },
        ],
      },
      {
        id: 'stock',
        title: 'Stock',
        messageId: 'sidebar.blueSoft.stock',
        type: 'collapse',
        icon: <TbBuildingWarehouse />,
        idsFuncionalidad: ['304', '312', '605', '502', '507', '524'],
        children: [
          {
            id: 'ingresosDeMercaderia',
            title: 'Ingresos de Mercadería',
            messageId: 'sidebar.blueSoft.stockIn',
            type: 'item',
            url: '/blueSoft/stock/ingresos',
            idsFuncionalidad: ['304', '312'],
          },
          {
            id: 'salidasDeMercaderia',
            title: 'Salidas de Mercadería',
            messageId: 'sidebar.blueSoft.stockOut',
            type: 'item',
            url: '/blueSoft/stock/salidas',
            idsFuncionalidad: ['605'],
          },
          {
            id: 'consultaStock',
            title: 'Stock',
            messageId: 'sidebar.blueSoft.stock',
            type: 'item',
            url: '/blueSoft/stock/consulta',
            idsFuncionalidad: ['502', '507', '524'],
          },
          {
            id: 'rotacionStock',
            title: 'Rotacion de Stock',
            messageId: 'sidebar.blueSoft.stockRotation',
            type: 'item',
            url: '/blueSoft/stock/rotacion',
            idsFuncionalidad: ['502', '507', '524'],
          },
        ],
      },
      {
        id: 'produccion',
        title: 'Producción',
        messageId: 'sidebar.blueSoft.production',
        type: 'collapse',
        icon: <TbSettings />,
        idsFuncionalidad: ['401', '403'],
        children: [
          {
            id: 'ordenesDeProduccion',
            title: 'Ordenes de Produccion',
            messageId: 'sidebar.blueSoft.ordenesDeProduccion',
            type: 'item',
            url: '/blueSoft/produccion/ordenesDeProduccion',
            idsFuncionalidad: ['401'],
          },
          {
            id: 'ordenesDeProceso',
            title: 'Órdenes de Proceso',
            messageId: 'sidebar.blueSoft.ordenesDeProceso',
            type: 'item',
            url: '/blueSoft/produccion/ordenesDeProceso',
            idsFuncionalidad: ['403'],
          },
        ],
      },
    ],
  },
];
export default routesConfig;
